import { createSelector } from 'reselect'

const getUserExtraData = state => state.user.extra

const adminOnboardingOfferTitle = createSelector(
	[getUserExtraData],
	extra => ({ offerTitle: extra && extra.notificationMessage ? extra.notificationMessage.offerTitle : ''})
)

export default adminOnboardingOfferTitle
